// api/attendance.js
// 来塾状況に関するAPIを実装する

import Api from './api_base'

export default {
  // GET /attendance その日の全ユーザの来塾情報を取得する
  get: () => {
    return Api.get('/attendance')
    .catch((err) => {
      console.log(err)
    })
  },
  // GET GET /attendance/{user_id} その日の指定ユーザの来塾情報を取得する
  getByUserId: (uid) => {
    return Api.get('/attendance/' + uid)
    .catch((err) => {
      console.log(err)
    })
  },
  // POST /attendance 指定ユーザの来塾情報を変更する（反転する）
  post: (uid) => {
    return Api.post('/attendance', {user_id: uid})
  }
}



// WEBPACK FOOTER //
// ./src/api/attendance.js